import {} from 'viem';
import { getChainId } from 'viem/actions';
import {} from 'viem/zksync';
import {} from './abstractClient.js';
import { createSession, } from './actions/createSession.js';
import { deployContract } from './actions/deployContract.js';
import { prepareTransactionRequest, } from './actions/prepareTransaction.js';
import { revokeSessions, } from './actions/revokeSessions.js';
import { sendTransaction, sendTransactionBatch, } from './actions/sendTransaction.js';
import { sendTransactionForSession } from './actions/sendTransactionForSession.js';
import { signMessage } from './actions/signMessage.js';
import { signTransaction } from './actions/signTransaction.js';
import { signTypedData } from './actions/signTypedData.js';
import { writeContract } from './actions/writeContract.js';
import { writeContractForSession } from './actions/writeContractForSession.js';
import { EOA_VALIDATOR_ADDRESS } from './constants.js';
import { toSessionClient } from './sessionClient.js';
export function sessionWalletActions(signerClient, publicClient, session) {
    return (client) => ({
        sendTransaction: (args) => sendTransactionForSession(client, signerClient, publicClient, args, session),
        writeContract: (args) => writeContractForSession(client, signerClient, publicClient, args, session),
    });
}
export function globalWalletActions(signerClient, publicClient, isPrivyCrossApp = false) {
    return (client) => ({
        getChainId: () => getChainId(client),
        createSession: (args) => createSession(client, publicClient, args),
        revokeSessions: (args) => revokeSessions(client, args),
        prepareAbstractTransactionRequest: (args) => prepareTransactionRequest(client, signerClient, publicClient, args),
        sendTransaction: (args) => sendTransaction(client, signerClient, publicClient, args, isPrivyCrossApp),
        sendTransactionBatch: (args) => sendTransactionBatch(client, signerClient, publicClient, args, isPrivyCrossApp),
        signMessage: (args) => signMessage(client, signerClient, args, isPrivyCrossApp),
        signTransaction: (args) => signTransaction(client, signerClient, args, EOA_VALIDATOR_ADDRESS),
        signTypedData: (args) => signTypedData(client, signerClient, args, isPrivyCrossApp),
        deployContract: (args) => deployContract(client, signerClient, publicClient, args, isPrivyCrossApp),
        writeContract: (args) => writeContract(Object.assign(client, {
            sendTransaction: (args) => sendTransaction(client, signerClient, publicClient, args, isPrivyCrossApp),
        }), signerClient, publicClient, args),
        toSessionClient: (signer, session) => toSessionClient({
            client: client,
            signer,
            session: session,
        }),
    });
}
//# sourceMappingURL=walletActions.js.map